import {
  groupInput,
  input,
  InputProvider,
  nonEmptyValidator,
} from "@redotech/ui/form";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const EPostGlobalCarrierInput = groupInput({
  account_number: input<string>({ validator: nonEmptyValidator }),
});

export type EPostGlobalCarrierValue = InputProvider.Value<
  typeof EPostGlobalCarrierInput
>;

export type EPostGlobalCarrierForm = InputProvider.Form<
  typeof EPostGlobalCarrierInput
>;

export const EPostGlobalCarrierDefault = (): EPostGlobalCarrierValue => ({
  account_number: "",
});

export const CreateEPostGlobalCarrierForm = memo(
  function CreateEPostGlobalCarrierForm({
    carrierInput,
  }: {
    carrierInput: EPostGlobalCarrierForm;
  }) {
    return (
      <RedoTextInput
        label="Account number"
        placeholder=""
        setValue={carrierInput.inputs.account_number.setValue}
        value={carrierInput.inputs.account_number.value}
      />
    );
  },
);
